export class NotificationFactory {
    generate() {
        let notification = {
            user:{
                name:"",
                _id:"",
                username:""
            },
            list:{
                project:[]
            },
            notification:[]
        };
        return notification;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/factories/notifications/notifications.factory.ts